/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .navigation-rounds[_ngcontent-%COMP%]{display:flex;width:10%;margin:20px auto;justify-content:space-around}[_nghost-%COMP%]   .navigation-rounds[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{width:10px;height:10px;background-color:#dee0e7;border-radius:50%}[_nghost-%COMP%]   .navigation-rounds[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]{background-color:#e38821}"];
export { styles as styles };
